import { useEffect } from "react";
import { scrollToElementById } from "@/lib/utils";

/**
 * On mount, if the URL has a hash, scrolls to the matching element after layout.
 */
export const useHashScrollToElement = () => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) {
      return;
    }
    window.requestAnimationFrame(() => {
      scrollToElementById(id);
    });
  }, []);
};
